






































import Vue from 'vue';
import JoinWrapper from './JoinWrapper.vue';
import CourseraService from '~/services/CourseraService';
import ChooseSubscriptionButton from './ChooseSubscriptionButton.vue';

export default Vue.extend({
    name: 'CourseraRedirect',
    components: {
        ChooseSubscriptionButton,
        JoinWrapper,
    },
    data() {
        return {
            loading: true,
            error: false,
            hasAccess: false,
            baseUrl: 'https://www.coursera.org/programs/highered-industry-projects-0ofqi',
            purchase: false,
        };
    },
    computed: {
        header(): string {
            return this.purchase
                ? this.$t('coursera.subscriptions.howTo.purchaseSuccessful').toString()
                : this.$t('coursera.subscriptions.howTo.accessGranted').toString();
        },
        redirectUrl(): string {
            return this.baseUrl + '?authMode=login&authProvider=highered&attemptSSOLogin=true';
        },
    },
    methods: {
        handleOpenCoursera() {
            window.open(this.redirectUrl, '_blank');
        },
    },
    mounted() {
        const params = new URLSearchParams(window.location.search);
        if (params.get('purchase') === 'true') this.purchase = true;

        CourseraService.checkHasAccess()
            .then(acc => {
                if (acc.access && acc.programs.length) this.baseUrl = acc.programs[0].url;
                this.hasAccess = acc.access;
            })
            .catch(() => (this.error = true))
            .finally(() => (this.loading = false));
    },
});
